import { AnalyticsTrackData } from 'models/Analytics';
import { Article, Shipment } from 'models/shipments';
import { getFutureMilestones } from 'utils/milestone.utils';

export function transformShipmentToAnalytics(
  shipment: Shipment | null,
  article: Article | null,
  dialogCard?: string | null
): Partial<AnalyticsTrackData> {
  const analyticsTrackData: Partial<AnalyticsTrackData> = {
    carbonNeutral: shipment?.carbonNeutral ? 'yes' : 'no',
    dialogCard: dialogCard ?? 'null',
    dynamicComms: '', // TODO populate this
    id: article?.articleId || 'null',
    addressType: article?.address?.addressType as string,
    atl: article?.atlEligible ? 'atl available' : 'atl unavailable',
    delegate: article?.collectionInstruction?.delegate?.allowed ? 'eligible' : 'ineligible',
    latestEvent: article?.events?.[0]?.eventCode || 'null',
    milestone: article?.milestones?.[0]?.name || 'null',
    redirect: article?.redirectStatus || 'null',
  };

  if (analyticsTrackData.milestone) {
    const futureMilestones = getFutureMilestones(analyticsTrackData.milestone, analyticsTrackData.addressType);
    analyticsTrackData.futureMilestone = futureMilestones?.[0] || 'no future milestone';
  }

  const firstArticle = shipment?.articles[0];
  analyticsTrackData.hasNickname = firstArticle?.nickname || 'null';

  analyticsTrackData.merchantBranded = shipment?.merchant?.logoUrl ? 'yes' : 'no';
  return analyticsTrackData;
}
